import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { DataProvider } from '../providers/data/data';
import { LoginPage } from '../pages/login/login';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;

  public todosSectores: boolean = false;
  public filtroSectores: string = '';

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, 
    private dataProvider: DataProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      this.rootPage = (this.dataProvider.isLoggedOn ? HomePage : LoginPage);
      
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts